import { createSelector } from 'reselect'
import { RootState } from '../store'

const getApp = (state: RootState) => state.app

export const getAppLoading = createSelector(
  getApp,
  (appState) => {
    return appState.bootstrapping && !appState.loaded
  }
)


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/selectors/app.ts